'use client';
import React from 'react';
import Link from 'next/link';
import { useCookieConsent } from '@/lib/consent/cookieConsent';

export default function CookieBanner() {
  const { ready, bannerOpen, accept, essentialOnly } = useCookieConsent();
  if (!ready || !bannerOpen) return null;

  const btn =
    'inline-flex min-h-[44px] flex-1 items-center justify-center rounded-lg border-2 border-[#C6A667] bg-[#F8F3E9] px-4 py-2.5 text-sm font-bold text-[#581C32] transition-all hover:brightness-95 active:scale-95 sm:flex-none sm:min-w-[11rem]';

  return (
    <div
      role="dialog"
      aria-label="Cookie preferences"
      className="cookie-banner fixed inset-x-0 bottom-0 z-[100] border-t-2 border-[#C6A667] bg-[#581C32] px-4 py-4 text-white shadow-2xl"
    >
      <div className="mx-auto flex w-full max-w-screen-xl flex-col gap-4 md:flex-row md:items-center md:justify-between md:gap-6">
        <p className="text-sm leading-relaxed text-white/90">
          We use essential cookies to keep the site and your login working. With your permission, we&apos;ll also allow
          optional cookies from embedded lesson videos (HeyGen).{' '}
          <Link href="/cookie-policy" className="font-semibold text-[#C6A667] underline underline-offset-2">
            Cookie Policy
          </Link>
        </p>
        <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:flex-shrink-0">
          <button type="button" onClick={accept} className={btn}>
            Accept optional cookies
          </button>
          <button type="button" onClick={essentialOnly} className={btn}>
            Essential only
          </button>
        </div>
      </div>
    </div>
  );
}
